module.exports = __webpack_public_path__ + "img/Holy See (Vatican City State).d6515cc8.svg";